// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController) 

import ViacepController from "./viacep_controller"
application.register("viacep", ViacepController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import ExpandableSectionsController from "./expandable_sections_controller"
application.register("expandable-sections", ExpandableSectionsController)

import LeafletMapController from "./leaflet_map_controller"
application.register("leaflet-map", LeafletMapController)

import GeoJSONImportController from "./geojson_import_controller"
application.register("geojson-import", GeoJSONImportController)

import StravaSyncController from "./strava_sync_controller"
application.register("strava-sync", StravaSyncController)

import StravaSyncV2Controller from "./strava_sync_v2_controller"
application.register("strava-sync-v2", StravaSyncV2Controller)
